<template>
  <div class="note-template">
    <div class="main">
      <!-- Title -->
      <div class="title_bar">
        <div class="left">
          <div class="title">
            {{ $t('NoteTemplate.Title') }}
          </div>
        </div>
      </div>
      <!-- TAB -->
      <el-tabs v-model="activeTab" class="note-template__tabs" @tab-click="handleTabClick">
        <el-tab-pane
          v-for="item in tabs" :key="item.id" :label="item.name"
          :name="item.id"
        />
      </el-tabs>
      <div class="note-template__title">
        {{ activeTabTitle }}
      </div>
      <div class="note-template__action">
        <el-input v-model="newNote" :placeholder="activeTabPlaceholder" maxlength="100"></el-input>
        <el-button class="note-template__create" plain :disabled="newNote.trim()===''" @click="addNote">
          {{ $t('General.Create') }}
        </el-button>
      </div>

      <el-table
        :data="notes"
        :empty-text="activeTabBlockWord"
      >
        <el-table-column
          label="#"
          type="index"
          width="50"
          prop="index"
        >
        </el-table-column>
        <el-table-column
          :label="$t('NoteTemplate.Content')"
        >
          <template slot-scope="scope">
            <div v-if="editState.idx!==scope.$index" class="note-template__note-content">
              {{ scope.row['Note'] }}
            </div>
            <el-input v-else v-model="editState.content" class="note-template__note-input" maxlength="100" :placeholder="activeTabPlaceholder"></el-input>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('NoteTemplate.Action')"
        >
          <template slot-scope="scope">
            <div v-if="editState.idx!==scope.$index" class="operate">
              <el-button size="mini" plain :disabled="editState.idx!==null && editState.idx!==scope.$index" @click="editNote(scope)">
                {{ $t('General.Edit') }}
              </el-button>
              <el-button size="mini" type="danger" plain :disabled="editState.idx!==null && editState.idx!==scope.$index" @click="deleteNote(scope)">
                {{ $t('General.Delete') }}
              </el-button>
            </div>
            <div v-else class="operate">
              <el-button size="mini" type="danger" @click="cancelNote(scope)">
                {{ $t('General.Cancel') }}
              </el-button>
              <el-button size="mini" type="success" :disabled="editState.content.trim()===''" @click="saveNote(scope)">
                {{ $t('General.Store') }}
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import { apiPoint } from '@/api/point/point.js'
export default {
  data () {
    const tabs = [
      {
        id: '1',
        name: this.$t('NoteTemplate.RechargeTab'),
        title: this.$t('NoteTemplate.RechargeCreateTitle'),
        placeholder: this.$t('NoteTemplate.RechargePlaceholder'),
        blockWord: this.$t('NoteTemplate.RechargeBlockWord')
      },
      {
        id: '2',
        name: this.$t('NoteTemplate.RestoreTab'),
        title: this.$t('NoteTemplate.RestoreCreateTitle'),
        placeholder: this.$t('NoteTemplate.RestorePlaceholder'),
        blockWord: this.$t('NoteTemplate.RestoreBlockWord')
      },
      {
        id: '3',
        name: this.$t('NoteTemplate.VoidTab'),
        title: this.$t('NoteTemplate.VoidCreateTitle'),
        placeholder: this.$t('NoteTemplate.VoidPlaceholder'),
        blockWord: this.$t('NoteTemplate.VoidBlockWord')
      },
      {
        id: '4',
        name: this.$t('NoteTemplate.RejectTab'),
        title: this.$t('NoteTemplate.RejectCreateTitle'),
        placeholder: this.$t('NoteTemplate.RejectPlaceholder'),
        blockWord: this.$t('NoteTemplate.RejectBlockWord')
      }
    ]
    const { id, title, placeholder, blockWord } = tabs.find(el => el.id === '1')
    const activeTab = id
    const activeTabTitle = title
    const activeTabBlockWord = blockWord
    const activeTabPlaceholder = placeholder
    const newNote = ''
    const editState = {
      id: null,
      idx: null,
      content: ''
    }

    return {
      activeTab,
      activeTabBlockWord,
      activeTabPlaceholder,
      activeTabTitle,
      editState,
      newNote,
      notes: [],
      tabs
    }
  },
  async mounted () {
    try {
      this.notes = await this.getNotes(this.activeTab)
    } catch (e) {
      console.log(e)
      this.notes = []
    }
  },
  methods: {
    async addNote () {
      try {
        await apiPoint.createNoteTemplate({ id: this.activeTab, note: this.newNote })
        this.$message({
          message: this.$t('NoteTemplate.CreateSuccess'),
          type: 'success'
        })
        this.notes = await this.getNotes(this.activeTab)
        this.newNote = ''
      } catch (e) {
        console.log(e)
      }
    },
    editNote ({ row, $index }) {
      this.editState.idx = $index
      this.editState.id = row.Id
      this.editState.content = row.Note
    },
    deleteNote ({ row }) {
      this.$confirm(this.$t('NoteTemplate.DeleteConfirm'), this.$t('General.AlertTitle'), {
        confirmButtonText: this.$t('General.OK'),
        cancelButtonText: this.$t('General.Cancel'),
        type: 'warning'
      }).then(async () => {
        try {
          await apiPoint.deleteNoteTemplate(row.Id)
          this.$message({
            message: this.$t('NoteTemplate.DeleteSuccess'),
            type: 'success'
          })
          this.notes = await this.getNotes(this.activeTab)
        } catch (e) {
          console.log(e)
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    cancelNote () {
      this.editState.idx = null
      this.editState.id = null
      this.editState.content = ''
    },
    async getNotes (id) {
      try {
        const res = await apiPoint.getNoteTemplates(id)
        return res.data.Data?.NoteTemplates
      } catch (e) {
        console.log(e)
        return []
      }
    },
    async saveNote () {
      try {
        await apiPoint.updateNoteTemplate({ id: this.editState.id, note: this.editState.content })
        this.editState.idx = null
        this.editState.id = null
        this.editState.content = ''
        this.$message({
          message: this.$t('NoteTemplate.UpdateSuccess'),
          type: 'success'
        })
        this.notes = await this.getNotes(this.activeTab)
      } catch (e) {
        console.log(e)
      }
    },
    async  handleTabClick () {
      try {
        this.activeTabTitle = this.tabs.find(el => el.id === this.activeTab).title
        this.activeTabBlockWord = this.tabs.find(el => el.id === this.activeTab).blockWord
        this.activeTabPlaceholder = this.tabs.find(el => el.id === this.activeTab).placeholder
        this.newNote = ''
        this.notes = await this.getNotes(this.activeTab)
        this.editState.idx = null
        this.editState.id = null
        this.editState.content = ''
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.note-template{
  @include mainLayer();

  ::v-deep .el-tabs{
    @include basicTabs;
  }

  ::v-deep .el-table{
    @include basicTable;
    width: 100%;
    &__body a.el-button--default.is-plain{
      color: #333
    }
  }

  &__tabs{
    margin-bottom: .5rem;
  }

  &__title{
    margin-bottom:0;
    text-align: left;
    margin-bottom:.5rem
  }

  &__action{
    display: flex;
    width: 50%;
    align-items: center;
    margin-bottom:2rem
  }

  &__create{
    margin-left:0.5rem
  }

  &__note-content,&__note-input{
    word-break: break-all;
  }
}
</style>
